/**
 * @desc 根据角色编码查询用户身份
 */
import { ProfileUser } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryProfileUserListByRoleCodeParameter = {
  roleCodes?: Array<string>
}

const method = 'GET'
const url = '/auth/profile/list/byRoleCode'

export const queryProfileUserListByRoleCodeApi = (
  params?: QueryProfileUserListByRoleCodeParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<ProfileUser>>({
    method,
    url,
    params,
    ...config
  })
}

queryProfileUserListByRoleCodeApi.method = method
queryProfileUserListByRoleCodeApi.url = url
